function formatNumber(number, locale = navigator?.language || 'en-GB') {
  return new Intl.NumberFormat(locale).format(number);
}

export default formatNumber;
